import { addToCartProduct } from "../pages/product";
import { formatMoney } from "../utils/price";
import { $all, $one } from "../utils/querySelector";

let variants;
let options;
let sellingPlan;
let variantSelected;
let button;

export function updateMount() {
  const addBundleToCart = document.getElementById("bundle-add-to-cart");
  if (addBundleToCart) {
    const inputCart = document.querySelector("#data-cart");
    addBundleToCart.addEventListener("click", () => { 
      const buttonCart = document.querySelector('#productDelete')
      const bundle = [];
      const objectCart = JSON.parse(inputCart.value);
      for (const key in objectCart) {
        const { variantId, quantity, selling_plan_id, properties } = objectCart[key];
        bundle.push({
          id: variantId,
          quantity,
          selling_plan: selling_plan_id,
          properties,
        });
      }
      if(!!buttonCart){
        const variantId = buttonCart.dataset.variantId;
        const result = bundle.some(item => item.id === variantId)

        result ? $one('.message-add-cart').style.display = "flex" : addToCartProduct("", "", bundle); 
      }else{
        addToCartProduct("", "", bundle);
      }
    });
  }
  if (
    document.getElementsByClassName("product-variant") &&
    document.getElementsByClassName("product-variant").length > 0
  ) {
    variants = JSON.parse(document.getElementById("variants").value);
    options = JSON.parse(document.getElementById("options").value);
    sellingPlan = $all("#selling-plan optgroup");
    variantSelected = document.getElementById("variant-selected").value;

    button = document.getElementById("add-to-cart");
    if (button) button.addEventListener("click", addToCart);

    const optionsSelect = document.querySelectorAll(
      ".product-variant .product-variant__options .product-variant__select"
    );
    if (optionsSelect) {
      optionsSelect.forEach((element) => {
        element.addEventListener("change", () => {
          selectOption(element);
        });
        selectOption(element);
      });
    }

    const optionsRadio = document.querySelectorAll(
      ".product-variant .product-variant__options .product-variant__radio-container .product-variant__radio"
    );
    if (optionsRadio) {
      optionsRadio.forEach((element) => {
        element.addEventListener("change", () => {
          selectOption(element);
        });
        if (element.checked) selectOption(element);
      });
    }

    if (optionsRadio.length === 0 && optionsSelect.length === 0) {
      const isVariants = JSON.parse($one("#variants").value);
      updateVariant(isVariants[0]);
    }
  }
}

function selectOption(element) {
  const dataType = element.parentNode.getAttribute("data-type");
  const selectedOptions = [element.value];

  const availableOptions = options.filter((item) => item !== dataType);

  if (availableOptions && availableOptions.length > 0) {
    availableOptions.forEach((option) => {
      const element = document.querySelector(
        `[data-type="${option}"] select, [data-type="${option}"] input:checked`
      );
      selectedOptions.push(element.value);
    });
  }

  updateVariant(
    variants.find(
      (item) =>
        JSON.stringify(item.options.sort(orderArray)) ===
        JSON.stringify(selectedOptions.sort(orderArray))
    )
  );
}

export function updateVariant(variant) {
  variantSelected = variant.id;
  document
    .getElementById("variant-selected")
    .setAttribute("value", variantSelected);

  if (
    $one(
      '.main-product-detail--buy-section input[id*=sabonner][type="radio"][name="actions"]:checked'
    )
  ) {
    updateSellingPlan(variant.title);
  }

  const textAddCart = document.getElementById("add-to-cart__information-add");
  const textSoldOut = document.getElementById("add-to-cart__information-out");

  if (variant.available) {
    button?.removeAttribute("disabled");
    textAddCart?.classList.remove("hidden");
    textSoldOut?.classList.add("hidden");
  } else {
    button?.setAttribute("disabled", "true");
    textAddCart?.classList.add("hidden");
    textSoldOut?.classList.remove("hidden");
  }

  const priceDom = $one(".main-product-detail--add-cart #add-to-cart .regular");
  const compareDom = $one(
    ".main-product-detail--add-cart #add-to-cart .compare"
  );
  const productcard_price = $one("#add-to-cart");
  let price_selling = variant.selling_plan_allocations;
  let compare_selling = variant.price;
  let price_normal = variant.price;
  let compare_normal = variant.compare_at_price;

  const suscriptionCheck = $one(
    '.main-product-detail--buy-section input[id*=sabonner][type="radio"][name="actions"]:checked'
  );
  if (price_selling.length > 0) {
    price_selling = variant.selling_plan_allocations[0].price;
  }

  if (suscriptionCheck) {
    updatePrice(
      productcard_price,
      compareDom,
      priceDom,
      price_selling,
      compare_selling
    );
  } else {
    updatePrice(
      productcard_price,
      compareDom,
      priceDom,
      price_normal,
      compare_normal
    );
  }
}

export function updatePrice(
  productcard_price,
  compareDom,
  priceDom,
  price_normal,
  price_compare
) {
  if(priceDom) {
    priceDom.textContent = formatMoney(price_normal);
  }

  if (compareDom) {
    if (price_compare > price_normal) {
      compareDom.textContent = formatMoney(price_compare);
    } else {
      compareDom.remove();
    }
  } else {
    if (price_compare > price_normal) {
      const elementCompare = document.createElement("span");
      elementCompare.classList.add("compare");
      elementCompare.textContent = formatMoney(price_compare);
      productcard_price.insertBefore(elementCompare, priceDom);
    }
  }
}

function addToCart() {
  
  let inputSellingPlan = null;
  if (
    $one(
      '.main-product-detail--buy-section input[id*=sabonner][type="radio"][name="actions"]:checked'
    )
  ) {
    inputSellingPlan = $one(
      ".main-product-detail--buy-section #selling-plan-value"
    ).value;
  }
  
  addToCartProduct(variantSelected, inputSellingPlan);
}

function orderArray(a, b) {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
}

function updateSellingPlan(variant) {
  const sellingPlanShow = sellingPlan.find(
    (element) => element.getAttribute("label") === variant
  );

  const dataSelling = sellingPlanShow.querySelectorAll("option");
  const inputSellingPlan = $one("#selling-plan-value");

  inputSellingPlan.innerHTML = "";

  for (const option of dataSelling) {
    const htmlOption = document.createElement("option");
    htmlOption.setAttribute("value", option.value);
    htmlOption.innerText = option.text;

    inputSellingPlan.append(htmlOption);
  }
}
